import { cn } from "@/lib/utils";

/** The same plain-text body is shown in the library and the approval screen. */
export const EmailPreview = ({
  subject,
  text,
  from,
  to,
  compact = false,
}: {
  subject: string;
  text: string;
  from: string;
  to: string;
  compact?: boolean;
}) => (
  <article
    aria-label="Предпросмотр письма"
    className={cn(
      "mx-auto min-w-0 w-full rounded-lg border bg-white text-zinc-900 shadow-sm [overflow-wrap:anywhere]",
      compact ? "max-w-[360px]" : "max-w-[720px]",
    )}
  >
    <header className="space-y-4 border-b border-zinc-200 p-5 sm:p-6">
      <h2 className="text-xl font-semibold leading-snug">
        {subject || "Тема письма"}
      </h2>
      <dl className="grid grid-cols-[auto_minmax(0,1fr)] gap-x-3 gap-y-1 text-sm">
        <dt className="text-zinc-600">От</dt>
        <dd>{from}</dd>
        <dt className="text-zinc-600">Кому</dt>
        <dd>{to}</dd>
      </dl>
    </header>
    <div className="whitespace-pre-wrap p-5 text-[15px] leading-7 sm:p-6">
      {text || "Здесь появится текст вашего письма."}
    </div>
  </article>
);
